import {makeStyles} from '@material-ui/core/styles';

export default () =>{
    let useStyles = makeStyles({
            main: {
              fontSize:"13px"
            },
            header: {
              display: "",
              padding: "20px !important",
              FlexDirection: "row",
              PaddingTop: "220px",
              TextAlign: "rigt",
              borderBottom: "1px solid #CCCCCC;",
              paddingBottom: "10px"
            },
            additem: {
              display: 'flex',
              justifyContent: 'space-between',
             
            },
            buttonright: {
              float: "right"
            },
            button:{
              paddingRight: "50px",
              paddingLeft: "50px",
              marginRight: "20px",
              textTransform: 'capitalize',
              fontWeight: 'bold',
              letterSpacing: 0
            },
            typebottom:{
              marginBottom: "15px"
            },
            body: {
              padding: "20px"
            },
            labeltext: {
              display: "flex",
            FlexDirection: "",
            PaddingTop: "20px",
            },
            column1:{
              paddingRight: "30px"
            },
            taxdrop: {
              background: "#f2f2f2",
              width: "300px",
              height: "30px",
              border: "none",
              borderLeft: "10px solid #f2f2f2",
              borderRight: "10px solid #f2f2f2",
              marginBottom: "20px",
              marginTop : "10px",
              color:"#112B42"
            },
            textfield: {
              background: "#f2f2f2",
              width: "300px",
              height: "30px",
              borderLeft: "10px solid #f2f2f2",
              borderRight: "10px solid #f2f2f2",
              marginBottom: "20px",
              marginTop : "10px"
            },
            label: {
              color: "#666666"
            }
    })
    return useStyles();
}